import { render, staticRenderFns } from "./app-logo.vue?vue&type=template&id=09a8e8b5&"
import script from "./app-logo.vue?vue&type=script&lang=js&"
export * from "./app-logo.vue?vue&type=script&lang=js&"
import style0 from "./app-logo.vue?vue&type=style&index=0&id=09a8e8b5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports